module.exports = __webpack_public_path__ + "img/device-box.84a878ad.png";